import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Select,
  MenuItem,
  TextField,
  Grid,
  InputLabel,
  FormControl,
} from "@mui/material";
import { MdDelete, MdVisibility } from "react-icons/md";
import axios from "axios";

const OrderList = () => {
  const [orders, setOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);

  const [filters, setFilters] = useState({
    status: "",
    date: "",
    orderId: "",
    name: "",
  });

  const fetchOrders = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(
        "https://ecom-api.applligentdemo.com/orders/getOrder",
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      const data = res.data;
      setOrders(data || []);
      
      setFilteredOrders(data || []);
    } catch (err) {
      console.error("Error fetching orders:", err);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  useEffect(() => {
    let filtered = [...orders];

    if (filters.status) {
      filtered = filtered.filter((o) => o.status === filters.status);
    }

    if (filters.date) {
      filtered = filtered.filter(
        (o) => new Date(o.createdAt).toISOString().slice(0, 10) === filters.date
      );
    }

    if (filters.orderId) {
      filtered = filtered.filter((o) =>
        o._id.toLowerCase().includes(filters.orderId.toLowerCase())
      );
    }

    if (filters.name) {
      filtered = filtered.filter((o) =>
        o.userId?.name?.toLowerCase().includes(filters.name.toLowerCase())
      );
    }

    setFilteredOrders(filtered);
  }, [filters, orders]);

  const handleStatusChange = async (id, status) => {
    try {
      await axios.put(`https://ecom-api.applligentdemo.com/order/updateOrder/${id}`, {
        status,
      });
      fetchOrders();
    } catch (err) {
      console.error("Status update error:", err);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure to delete this order?")) {
      await axios.delete(`https://ecom-api.applligentdemo.com/order/deleteOrder/${id}`);
      fetchOrders();
    }
  };

  return (
    <>
      {/* Filters */}
      <Paper sx={{ padding: 2, marginBottom: 2 }}>
        <Grid container spacing={4}>
          <Grid item xs={12} sm={3}>
            <FormControl fullWidth>
              <InputLabel>Status</InputLabel>
              <Select
                style={{ width: "120px" }}
                value={filters.status}
                label="Status"
                onChange={(e) =>
                  setFilters({ ...filters, status: e.target.value })
                }
              >
                <MenuItem value="">All</MenuItem>
                <MenuItem value="Pending">Pending</MenuItem>
                <MenuItem value="Shipped">Shipped</MenuItem>
                <MenuItem value="Delivered">Delivered</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              label="Date"
              type="date"
              fullWidth
              InputLabelProps={{ shrink: true }}
              value={filters.date}
              onChange={(e) => setFilters({ ...filters, date: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              label="Order ID"
              fullWidth
              value={filters.orderId}
              onChange={(e) =>
                setFilters({ ...filters, orderId: e.target.value })
              }
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              label="Customer Name"
              fullWidth
              value={filters.name}
              onChange={(e) => setFilters({ ...filters, name: e.target.value })}
            />
          </Grid>
        </Grid>
      </Paper>

      {/* Orders Table */}
      <TableContainer component={Paper}>
        <Table>
          <TableHead sx={{ backgroundColor: "#A7C1A8" }}>
            <TableRow>
              <TableCell>S.No</TableCell>
              <TableCell>Order ID</TableCell>
              <TableCell>Customer</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Price</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Ordered At</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredOrders.map((order, index) => (
              <TableRow key={order._id}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{order._id}</TableCell>
                <TableCell>{order.userId?.name}</TableCell>
                <TableCell>{order.userId?.email}</TableCell>
                <TableCell>₹{order.totalAmount}</TableCell>
                <TableCell>
                  <Select
                    value={order.status}
                    onChange={(e) =>
                      handleStatusChange(order._id, e.target.value)
                    }
                    size="small"
                  >
                    <MenuItem value="pending">Pending</MenuItem>
                    <MenuItem value="shipped">Shipped</MenuItem>
                    <MenuItem value="delivered">Delivered</MenuItem>
                  </Select>
                </TableCell>
                <TableCell>
                  {new Date(order.createdAt).toLocaleDateString()}
                </TableCell>
                <TableCell>
                  <IconButton
                    onClick={() =>
                      (window.location.href = `/view-order/${order._id}`)
                    }
                  >
                    <MdVisibility />
                  </IconButton>
                  <IconButton onClick={() => handleDelete(order._id)}>
                    <MdDelete />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
            {filteredOrders.length === 0 && (
              <TableRow>
                <TableCell colSpan={8} align="center">
                  No orders found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default OrderList;
